// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"
import "./src/styles/tailwind.css"
import "./src/styles/global.scss"
import "@fontsource/bebas-neue"
import "@fontsource/karla"
import "@fontsource/dm-serif-text"

import { Helmet } from "react-helmet"
import React from "react"

export function onServiceWorkerUpdateReady() {
  window.location.reload(true)
}

export const wrapRootElement = ({ element }) => {
  return (
    <>
      <Helmet>
        <script
          src="https://cdn.userway.org/widget.js"
          data-account="0DE98oTtJP"
        ></script>
      </Helmet>
      {element}
    </>
  )
}
